import { useEffect, useState } from 'react';
import {
    Card, Table, TableBody, TableCell, Container, TableContainer, TableRow, Button, TablePagination,
    Typography, Divider
} from '@mui/material';
import { useDispatch, useSelector } from 'react-redux';
import Page from './../../components/Page';
import Scrollbar from './../../components/Scrollbar';
import { UserListHead } from '../../sections/@dashboard/user';
import HeaderBreadcrumbs from './../../components/HeaderBreadcrumbs';
import moment from 'moment-timezone';
import "./../BannerManagement/BannerManagement.css"
import { GetWithDrawalListAction, WalletTransAction } from 'src/redux/actions/TransactionsActions';
import Box from '@mui/material/Box';
import Modal from '@mui/material/Modal';
import * as React from 'react';
import { FetchUserDetailAction } from "src/redux/actions/UsersAction";


const style = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: 800,
    bgcolor: 'background.paper',
    border: '2px solid #000',
    boxShadow: 24,
    pt: 2,
    px: 4,
    pb: 3,
};


export default function WithdrawalRequest() {
    const dispatch = useDispatch();
    const withDrawalData = useSelector(state => state.transaction_manager.withdrawal_list.data)
    const loadingSelector = useSelector(state => state.transaction_manager.loading)
    const [page, setPage] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(25);
    const [open, setOpen] = useState(false);
    const [childOpen, setChildOpen] = useState(false);

    const [requestAction, setRequestAction] = useState({});

    const userDetailState = useSelector(
        (state) => state.users?.user_detail?.data?.data,
    );
    const userDetailLoader = useSelector(
        (state) => state.users?.user_detail?.loading
    );
    let userDetails = userDetailState !== undefined && userDetailState;

    const walletData = useSelector(state => state.transaction_manager?.trans_request?.data)
    console.log("walletData--->>", walletData)

    useEffect(() => {
        dispatch(GetWithDrawalListAction((page + 1), rowsPerPage));
    }, [dispatch, page, rowsPerPage])


    const handleChangePage = (_, newPage) => {
        setPage(newPage);
    };
    const handleChangeRowsPerPage = (event) => {
        setRowsPerPage(parseInt(event.target.value, 10));
        setPage(0);
    };

    const handleOpen = (e, id, amount, emailid, transId) => {
        console.log("id11===>>", id);
        setRequestAction({ transId, amount, emailid });
        dispatch(FetchUserDetailAction({ userid: id }));
        setOpen(true);
    };
    const handleClose = () => {
        setOpen(false);
    };

    const onClickRequest = (e, userDetl, type) => {
        console.log("userDetl--->>", userDetl?.userbank_account?.upi);
        let sRequestAction = { ...requestAction, type: type, userUPI: userDetl?.userbank_account?.upi }
        setRequestAction(sRequestAction);

        setChildOpen(true);

    }

    const handleChildClose = () => {
        setChildOpen(false);
    }

    const onClickAssRequest = (v, u, t, p) => {
        dispatch(WalletTransAction({ transId: requestAction.transId, type: requestAction.type, payoutTyp: p }));
        handleChildClose();
        handleClose();
        //dispatch(GetWithDrawalListAction((page + 1), rowsPerPage));
        window.location.reload();
    }

    console.log("requestAction--->>", requestAction);
    return (<>
        <Page title="Withdrawal Request">

            {/* {(loadingSelector || userDetailLoader) ? <Loader /> : null} */}

            <Container maxWidth="lg">
                <HeaderBreadcrumbs
                    heading="Withdrawal Request"
                    links={[
                        { name: 'Dashboard', href: "/dashboard/app" },
                        { name: 'Withdrawal Request' }
                    ]}
                />

                <Card>
                    <Scrollbar>
                        <TableContainer sx={{ minWidth: 800 }}>
                            <Table>
                                <UserListHead
                                    headLabel={[
                                        { id: "c_no", label: "Sr no.", alignRight: false },
                                        { id: 'name', label: 'User Name', alignRight: false },
                                        { id: 'email', label: 'Email', alignRight: false },
                                        { id: 'phone', label: 'Phone', alignRight: false },
                                        { id: 'amount', label: 'Amount', alignRight: false },
                                        // { id: 'type', label: 'Type', alignRight: false },
                                        { id: 'status', label: 'Status', alignRight: false },
                                        { id: 'request_date', label: 'Requested Date', alignRight: false }
                                    ]}
                                />
                                <TableBody>
                                    {withDrawalData &&
                                        withDrawalData.data.Withdraw_list.sort((a, b) =>
                                            a.txdate < b.txdate ? 1 : -1
                                        ).map((value, index) => {
                                            return (
                                                <TableRow hover key={index}>
                                                    <TableCell component="th" scope="row">
                                                        {page * rowsPerPage + (index + 1)}.
                                                    </TableCell>
                                                    <TableCell component="th" scope="row">{value.user?.user_profile?.name ? value.user.user_profile.name : "-"}</TableCell>
                                                    <TableCell component="th" scope="row">{value.user?.email ? value.user.email : "-"}</TableCell>
                                                    <TableCell component="th" scope="row">{value.user?.phone ? value.user.phone : "-"}</TableCell>
                                                    <TableCell component="th" scope="row">{value?.amount ? value?.amount : "0"}</TableCell>
                                                    {/* <TableCell component="th" scope="row">
                                                        {value?.atype ?
                                                            value?.atype === "bns" ? "Bonus" :
                                                                value?.atype === "bal_add" ? "Add" :
                                                                    "Balance"
                                                            : "-"
                                                        }
                                                    </TableCell> */}
                                                    <TableCell component="th" scope="row">{value?.status ? value?.status : "-"}</TableCell>
                                                    <TableCell component="th" scope="row">{value?.txdate ? moment(value.txdate * 1000).utc().format("DD/MM/YY hh:mm A") : "-"}</TableCell>
                                                    <TableCell component="th" scope="row"><Button onClick={(e) => handleOpen(e, value.user.id, value?.amount, value.user.email, value.id)}>Open modal</Button></TableCell>
                                                </TableRow>
                                            );
                                        })}
                                </TableBody>
                            </Table>
                        </TableContainer>
                    </Scrollbar>
                    <TablePagination
                        rowsPerPageOptions={[25, 50, 100, 150, 200]}
                        component="div"
                        count={withDrawalData && withDrawalData.data.total_count}
                        rowsPerPage={rowsPerPage}
                        page={page}
                        onPageChange={handleChangePage}
                        onRowsPerPageChange={handleChangeRowsPerPage}
                    />


                </Card>
            </Container>
        </Page>

        <Modal
            open={open}
            aria-labelledby="parent-modal-title"
            aria-describedby="parent-modal-description"
        >

            <Box sx={style}>
                <Typography
                    id="modal-modal-title"
                    style={{ marginBottom: 20 }}
                    align={"center"}
                    variant="h6"
                    component="h2"
                > Bank Details </Typography>
                <Divider />

                <TableContainer fullWidth>
                    <Table>
                        <TableBody>
                            <TableCell>
                                <TableRow>
                                    <TableCell component="th" scope="row"> Name </TableCell>
                                    <TableCell align="left"> {userDetails?.user_profile?.name
                                        ? userDetails?.user_profile?.name
                                        : "--"}</TableCell>
                                </TableRow>
                                <TableRow>
                                    <TableCell component="th" scope="row"> Email </TableCell>
                                    <TableCell align="left"> {userDetails.email ? userDetails.email : "--"}</TableCell>
                                </TableRow>
                                <TableRow>
                                    <TableCell component="th" scope="row"> Phone </TableCell>
                                    <TableCell align="left"> {userDetails.phone ? userDetails.phone : "--"}</TableCell>
                                </TableRow>
                                <TableRow>
                                    <TableCell component="th" scope="row"> Current Balance </TableCell>
                                    <TableCell align="left"> {userDetails.walletbalance ? userDetails.walletbalance : "--"}</TableCell>
                                </TableRow>
                                <TableRow>
                                    <TableCell component="th" scope="row"> Current Win Balance </TableCell>
                                    <TableCell align="left"> {userDetails.wltwin ? userDetails.wltwin : "--"}</TableCell>
                                </TableRow>
                                <TableRow>
                                    <TableCell component="th" scope="row"> Request Amount </TableCell>
                                    <TableCell align="left"> {requestAction.amount}</TableCell>
                                </TableRow>
                            </TableCell>
                            <TableCell>
                                <TableRow>
                                    <TableCell component="th" scope="row"> Account Holder Name </TableCell>
                                    <TableCell align="left"> {userDetails?.userbank_account?.acholdername ? userDetails?.userbank_account?.acholdername : "-"} </TableCell>
                                </TableRow>

                                <TableRow>
                                    <TableCell component="th" scope="row"> Bank Name </TableCell>
                                    <TableCell align="left"> {userDetails?.userbank_account?.bankname ? userDetails?.userbank_account?.bankname : "-"} </TableCell>
                                </TableRow>

                                <TableRow>
                                    <TableCell component="th" scope="row"> Account Number </TableCell>
                                    <TableCell align="left"> {userDetails?.userbank_account?.acno ? userDetails?.userbank_account?.acno : "-"} </TableCell>
                                </TableRow>

                                <TableRow>
                                    <TableCell component="th" scope="row"> IFSC Code </TableCell>
                                    <TableCell align="left">  {userDetails?.userbank_account?.ifsccode ? userDetails?.userbank_account?.ifsccode : "-"} </TableCell>
                                </TableRow>

                                <TableRow>
                                    <TableCell component="th" scope="row"> Bank Image </TableCell>
                                    <TableCell align="left">
                                        <img src={userDetails?.userbank_account?.image ? userDetails?.userbank_account?.image : "/no_image.png"} className="img-fluid" alt={userDetails?.userbank_account?.acholdername} width="200" />
                                    </TableCell>
                                </TableRow>

                                <TableRow>
                                    <TableCell component="th" scope="row"> UPI ID </TableCell>
                                    <TableCell align="left">  {userDetails?.userbank_account?.upi ? userDetails?.userbank_account?.upi : "-"} </TableCell>
                                </TableRow>

                            </TableCell>

                        </TableBody>
                    </Table>
                </TableContainer>

                <div style={{ marginTop: 20, display: "flex", alignItems: "center", justifyContent: "center" }}>
                    <Button onClick={handleClose}>Close</Button>
                    <Button variant="contained" color="error" onClick={(e) => onClickRequest(e, userDetails, "decline")} style={{ marginLeft: 10 }} >Decline</Button>
                    <Button variant="contained" color="success" onClick={(e) => onClickRequest(e, userDetails, "accept")} style={{ marginLeft: 10 }}>Accept</Button>
                </div>


            </Box>

        </Modal>

        <Modal
            open={childOpen}
            aria-labelledby="child-modal-title"
            aria-describedby="child-modal-description"
        >
            <Box sx={{ ...style, width: 500 }}>
                <h2 id="child-modal-title">Are you sure, you want to {requestAction.type} ?</h2>
                <p id="child-modal-description">
                    <TableContainer fullWidth>
                        <Table>
                            <TableBody>

                                <TableRow>
                                    <TableCell component="th" scope="row"> Email ID </TableCell>
                                    <TableCell align="left"> {requestAction.emailid}</TableCell>
                                </TableRow>
                                <TableRow>
                                    <TableCell component="th" scope="row"> Request Amount </TableCell>
                                    <TableCell align="left"> {requestAction.amount} </TableCell>
                                </TableRow>



                            </TableBody>
                        </Table>
                    </TableContainer>
                </p>
                <div style={{ marginTop: 20, display: "flex", alignItems: "center", justifyContent: "center" }}>
                    <Button onClick={handleChildClose}>Close</Button>
                    <Button variant="contained" color={(requestAction.type === "accept") ? "success" : "error"} onClick={(e) => onClickAssRequest(e, userDetails, requestAction.type, 1)}>{requestAction.type === "accept" ? "Accept Bank" : "Decline Bank"}</Button>


                    {requestAction.userUPI != null ?
                        <Button variant="contained" color={(requestAction.type === "accept") ? "success" : "error"} onClick={(e) => onClickAssRequest(e, userDetails, requestAction.type, 2)} style={{ marginLeft: 20, }}>{requestAction.type === "accept" ? "Accept UPI" : "Decline UPI"}</Button>
                        :
                        null
                    }

                    <Button style={{ marginLeft: 20, }} variant="contained" color={(requestAction.type === "accept") ? "success" : "error"} onClick={(e) => onClickAssRequest(e, userDetails, requestAction.type, 3)}>{requestAction.type === "accept" ? "Accept Manual" : "Decline Manual"}</Button>

                </div>

            </Box>
        </Modal>
    </>);
}
